import moment from 'moment';
import { IMemberInfoList, ITeamInfoList, filterObjType } from '@models/manager/account/accountModel';
import { CommonUtil } from '@utils/common/common';

export class TeamMember {
  teamList(responseData, clickHandler) {
    const _data: ITeamInfoList[] = CommonUtil.getArrayByValidate(responseData);
    const columns = [
      {
        name: 'Manager Email',
        selector: (row) => row.managerEmail,
        cell: (row) => row.managerEmail,
        sortable: true,
        minWidth: '120px',
      },
      {
        name: 'Team Name',
        selector: (row) => row.teamName,
        cell: (row) => (
          <div>
            <button style={{ color: 'red' }} onClick={() => clickHandler(row)}>
              {row.teamName}
            </button>
          </div>
        ),
        sortable: true,
        button: true,
      },
      {
        name: 'Status',
        selector: (row) => row.status,
        cell: (row) => row.status,
        sortable: true,
        maxWidth: '45px',
      },
      {
        name: 'Reg Date',
        selector: (row) => row.regDate,
        cell: (row) => moment(row.regDate).format('YYYY-MM-DD'),
        sortable: true,
        maxWidth: '120px',
      },
      {
        name: 'Expire Date',
        selector: (row) => row.expireDate,
        cell: (row) => moment(row.expireDate).format('YYYY-MM-DD'),
        sortable: true,
        maxWidth: '120px',
      },
    ];

    return {
      data: _data,
      columns,
    };
  }

  memberList(responseData, filterObj?: filterObjType) {
    const _data: IMemberInfoList[] = CommonUtil.getArrayByValidate(responseData);
    const columns = [
      {
        name: 'Member Email',
        selector: (row) => row.email,
        cell: (row) => row.email,
        sortable: true,
        minWidth: '120px',
      },
      {
        name: 'Role',
        selector: (row) => row.role,
        cell: (row) => row.role,
        sortable: true,
        maxWidth: '45px',
      },
      {
        name: 'Status',
        selector: (row) => row.status,
        cell: (row) => row.status,
        sortable: true,
        maxWidth: '60px',
      },
      {
        name: 'Reg Date',
        selector: (row) => row.regDate,
        cell: (row) => moment(row.regDate).format('YYYY-MM-DD'),
        sortable: true,
        maxWidth: '120px',
      },
      {
        name: 'Expire Date',
        selector: (row) => row.expireDate,
        cell: (row) => moment(row.expireDate).format('YYYY-MM-DD'),
        sortable: true,
        maxWidth: '120px',
      },
    ];

    let data = _data;
    // 필터링 조건
    if (filterObj) {
      const { type, searchText } = filterObj;
      // select 에 대한 type
      switch (type) {
        case 'email':
          data = data.filter((obj) => {
            return obj.email.includes(searchText) ? true : false;
          });
          break;
        case 'role':
          data = data.filter((obj) => {
            return obj.role.includes(searchText) ? true : false;
          });
          break;
        case 'status':
          data = data.filter((obj) => {
            return obj.status.includes(searchText) ? true : false;
          });
          break;
        default: // 'all' 일때
          data = data.filter((obj) => {
            if (obj.email.includes(searchText) || obj.role.includes(searchText) || obj.status.includes(searchText)) {
              return true;
            } else {
              return false;
            }
          });
          break;
      }
    }

    return {
      data,
      columns,
    };
  }
}
